<template>
  <div id="About" style="width:1050px;height:720px">
    <herder msg="智慧煤矿三维可视化系统" />
    <!-- 头部 -->
    <coal-left :btnshow="btnshow" />
    <!-- 左边组件 -->
    <coal-right :btnshow="btnshow" />
    <!-- 右边组件 -->
    <coal-buttom :btnshow="btnshow" ref="mybuttom" />
    <coal-nav />
    <coal-tunnel-btn :btnshow="btnshow" />
    <tunnel-details v-show="!btnshow && nowpage == 3" />
    <coal-details v-show="!btnshow && nowpage == 4" />
    <tunnelDetailstwo v-show="btnshow && nowpage == 1" />
    <coalDetailstwo v-show="btnshow && nowpage == 2" />

    <!-- 下方导航组件 -->
    <!--<div class="test" @click="gojjj">进入掘进机</div>-->
  </div>
</template>
<script>
import herder from "@/components/dp/herder.vue";
import coalLeft from "@/components/dp/left";
import coalRight from "@/components/dp/right";
import coalButtom from "@/components/dp/coalbutton";
import coalTunnelBtn from "@/components/dp/coalTunnelBtn";
import coalNav from "@/components/dp/coalNav";
import tunnelDetails from "@/components/dp/tunnelDetails";
import coalDetails from "@/components/dp/coalDetails";
import tunnelDetailstwo from "@/components/dp/tunnelDetailstwo";
import coalDetailstwo from "@/components/dp/coalDetailstwo";
export default {
  data() {
    return {
      btnshow: true,
      nowpage: 0
    };
  },

  components: {
    herder,
    coalLeft,
    coalRight,
    coalButtom,
    coalNav,
    coalTunnelBtn,
    coalDetails,
    tunnelDetails,
    coalDetailstwo,
    tunnelDetailstwo
  },
  mounted() {
    window.gojjj = this.gojjj;
    this.emit.$on("item3", e => {
      this.btnshow = true;
      this.$refs.mybuttom.item1(e);
      this.nowpage = e;
    });
    this.emit.$on("item", e => {
      // console.log(e, "dada333");
      this.nowpage = e;
    });
  },
  methods: {
    bianhuang() {
      this.$parent.bianhuang();
    },
    bianhong() {
      this.$parent.bianhong();
    },
    gojjj() {
      this.btnshow = !this.btnshow;
      if (this.nowpage == 1) {
        this.emit.$emit("item", 3);
      } else if (this.nowpage == 2) {
        this.emit.$emit("item", 4);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.test {
  position: absolute;
  left: 500px;
  top: 10px;
  background: red;
}
</style>
